import * as angular from "angular";
import {IController} from "angular";
import {AccountModel} from "../../angular/models/account.model";

export class SupplyAccountPreferencesComponent implements IController {

  account: AccountModel;
  preferences: any;
  onActiveChange: Function;

  constructor() {
  }

}

angular
  .module('bringoz.admin.accounts')
  .component('supplyAccountPreferences', {
    bindings: {
      account: '<',
      preferences: '<',
      onActiveChange: '&'
    },
    template: require('./supply-account-preferences.html').default,
    controller: SupplyAccountPreferencesComponent
  });
